import React from 'react';
import { FileText, GraduationCap, Users, Scale, AlertCircle, Stethoscope } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
export function Services() {
  const services = [{
    icon: <Users className="w-8 h-8 text-blue-700" data-id="element-113" />,
    title: 'Birth Certificates',
    desc: 'Exact translation required by USCIS for residency and citizenship processes.'
  }, {
    icon: <GraduationCap className="w-8 h-8 text-blue-700" data-id="element-114" />,
    title: 'Diplomas and Degrees',
    desc: 'Academic validation for universities and employers in the United States.'
  }, {
    icon: <FileText className="w-8 h-8 text-blue-700" data-id="element-115" />,
    title: 'Marriage/Divorce Certificates',
    desc: 'Certified vital documents for immigration or legal processes.'
  }, {
    icon: <Scale className="w-8 h-8 text-blue-700" data-id="element-116" />,
    title: 'Legal Documents',
    desc: 'Contracts, powers of attorney, and rulings translated with legal precision.'
  }, {
    icon: <AlertCircle className="w-8 h-8 text-blue-700" data-id="element-117" />,
    title: 'Criminal Records',
    desc: 'Certified translation of police records for visas and immigration.'
  }, {
    icon: <Stethoscope className="w-8 h-8 text-blue-700" data-id="element-118" />,
    title: 'Medical Documents',
    desc: 'Medical histories and certificates translated by experts.'
  }];
  return <section id="servicios" className="py-20 bg-white scroll-mt-24" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-122">
            Documents We Translate and Certify
          </h2>
          <p className="text-lg text-gray-600" data-id="element-123">
            All of our translations meet the strict requirements of USCIS,
            courts, and universities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-124">
          {services.map((service, index) => <div key={index} className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-125">
              <div className="bg-blue-100 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-126">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-127">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-128">{service.desc}</p>
              <WhatsAppButton text="Get a quote for this document" size="sm" message={`Hi, I need a quote to translate: ${service.title}`} className="w-full bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:text-green-700" data-id="element-129" />
            </div>)}
        </div>
      </div>
    </section>;
}